module.exports = __webpack_public_path__ + "static/media/autoCADAddons4.d3a81fd8.png";